import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from "@angular/core";

import { AlertsService } from "../../../../../../apis/networkdashboard/rest/services";

interface WiredAlert {
  startsAt: string;
  endsAt: string;
  updatedAt: string;
  annotations?: { summary?: string; __values__?: string };
  labels?: Record<string, string>;
}

@Component({
  selector: "alerts-section",
  templateUrl: "alerts-section.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, DatePipe, TranslatePipe],
})
export class AlertsSection {
  private readonly alertsService = inject(AlertsService);

  protected readonly subscriptionId = input.required<string>();

  private readonly alertsResource = resource({
    params: () => this.subscriptionId(),
    loader: ({ params: subscriptionId }) =>
      this.alertsService.getSubscriptionAlerts({ subscription_id: subscriptionId }).then((alerts) =>
        (alerts as WiredAlert[]).map((a) => ({
          summary: a.annotations?.summary ?? "",
          startsAt: new Date(a.startsAt),
          endsAt: new Date(a.endsAt),
          updatedAt: new Date(a.updatedAt),
          labels: a.labels ?? {},
          values: JSON.parse(a.annotations?.__values__ ?? "{}"),
        })),
      ),
  });

  protected readonly alerts = computed(() => this.alertsResource.value() ?? []);
}
